import(/* webpackMode: "eager" */ "/vercel/path0/components/Common/LazyImage/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Common/LazyVideo/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Modules/Marquee/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Modules/Slider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Modules/Text/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Singles/FeaturedProduct/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Singles/ProductComponent/ProductComponent.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Modules/CenteredImages/CenteredImages.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Modules/SideImage/SideImage.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Modules/SmallBigImages/SmallBigImages.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Singles/ProductComponent/ProductTitle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
